module.exports = __webpack_public_path__ + "img/bef59ff.jpg";